export default {
  data: () => ({
    meta: {
      title: null
    }
    // _title: ''
  }),

  computed: {
    title() {
      return this.meta.title || process.env.VUE_APP_TITLE || 'HNB'
    }
  },

  watch: {
    '$route.path'() {
      this.setMeta()
    },
    meta: {
      deep: true,
      handler() {
        if (typeof document !== 'undefined') {
          document.title = this.title
        }
      }
    }
  },

  created() {
    this.setMeta()
  },

  mounted() {
    this.bootstrapMeta()
  },

  methods: {
    bootstrapMeta() {
      if (typeof document === 'undefined') return
      // this._title = document.title
      this.setMeta()
    },
    setMeta() {
      const { title } = this.$route.meta
      if (!title) {
        return false
      }
      const locale = this.$i18n.locale
      const meta = this.$i18n.getLocaleMessage(locale)._meta || {}
      this.meta.title = meta[title] || title
      this.meta.title = meta[title] || this.getFallbackMeta(title) || title
    },
    getFallbackMeta(code) {
      const fallbackMeta =
        this.$i18n.getLocaleMessage(this.$i18n.fallbackLocale)._meta || {}
      if (process.env.NODE_ENV === 'development') {
        console.warn('Falling back to english meta for ' + (code || '/'))
      }
      return fallbackMeta[code]
    }
  }
}
